import { EXTENSION_ID, MANAGER_MESSAGE_BUS } from '../consts/managerExtension';

const sendMessageManagerBus = ({
  direction,
  urlPattern,
  focus = true,
  payload,
}: {
  direction: string;
  urlPattern: string;
  focus?: boolean;
  payload: unknown;
}) =>
  new Promise((resolve, reject) => {
    chrome.runtime.sendMessage(
      EXTENSION_ID,
      {
        action: MANAGER_MESSAGE_BUS,
        direction,
        focus,
        urlPattern,
        payload,
      },
      response => {
        if (response) {
          resolve(response);
        } else {
          reject();
        }
      }
    );
  });

export default sendMessageManagerBus;
